import apiInstance from "config/axiosInstance";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const GetAllRoleList = createAsyncThunk(
  "role/GetAllRoleList",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("settings/rolesList", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const AddNewRole = createAsyncThunk(
  "role/AddNewRole",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("settings/rolesCreate", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const DeleteRole = createAsyncThunk(
  "role/DeleteRole",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`settings/rolesDelete/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
